import { Placeholder } from 'journeys/portal/Forms/Sections.constants';

export const AsFoundTestTableSectionDataP51 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 6,
                    marginTop: '15px',
                },
                {
                    key: 'Comments',
                    label: 'Comments',
                    isLabel: true,
                    xs: 6,
                    fontWeight: '700',
                    fontSize: '9pt',
                    padding: '12px 0 0 2rem',
                }]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F1078ExcessiveSurfaceCorrosion',
                    label: 'Any excessive surface corrosion on valve body?',
                    value: formData.F1078ExcessiveSurfaceCorrosion,
                    isDropdown: true,
                    placeholder: Placeholder.SELECT_YES_OR_NO,
                    options: [
                        { name: Placeholder.SELECT_YES_OR_NO, value: '' },
                        { name: 'YES', value: 'YES' },
                        { name: 'NO', value: 'NO' }],
                    isRequired: true,
                    labelWidth: '57.5%',
                    width: '42.5%',
                    marginLeft: '8px',
                    textAlign: 'center',
                    xs: 6,
                    rootMarginRight: '0px',
                    inputTextAlign: 'center',
                    height: '1.5rem',
                    borderBottom: '0'
                },
                {
                    key: 'F1082Comment1',
                    value: formData.F1082Comment1,
                    xs: 6,
                    labelWidth: '0%',
                    width: '100%',
                    marginRight: '0.5rem',
                    height: '1.25rem',
                    textAlign: 'center',
                    borderBottom: '0',
                    marginLeft: '1.5rem',
                    maxLength: '50'

                }
            ]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F1079SignificantPipingVibration',
                    label: 'Any significant piping vibration?',
                    value: formData.F1079SignificantPipingVibration,
                    isDropdown: true,
                    placeholder: Placeholder.SELECT_YES_OR_NO,
                    options: [
                        { name: Placeholder.SELECT_YES_OR_NO, value: '' },
                        { name: 'YES', value: 'YES' },
                        { name: 'NO', value: 'NO' }],
                    isRequired: true,
                    labelWidth: '57.5%',
                    width: '42.5%',
                    marginLeft: '8px',
                    textAlign: 'center',
                    xs: 6,
                    rootMarginRight: '0px',
                    inputTextAlign: 'center',
                    height: '1.5rem',
                    borderBottom: '0'
                },
                {
                    key: 'F1083Comment2',
                    value: formData.F1083Comment2,
                    xs: 6,
                    marginRight: '0.5rem',
                    height: '1.25rem',
                    labelWidth: '0%',
                    width: '100%',
                    textAlign: 'center',
                    borderBottom: '0',
                    marginLeft: '1.5rem',
                    maxLength: '50'

                }
            ]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'F1081IsValveNameplateMissing',
                    label: 'Is valve nameplate missing or not readable?',
                    value: formData.F1081IsValveNameplateMissing,
                    isDropdown: true,
                    placeholder: Placeholder.SELECT_YES_OR_NO,
                    options: [
                        { name: Placeholder.SELECT_YES_OR_NO, value: '' },
                        { name: 'YES', value: 'YES' },
                        { name: 'NO', value: 'NO' }],
                    isRequired: true,
                    labelWidth: '57.5%',
                    width: '42.5%',
                    marginLeft: '8px',
                    textAlign: 'center',
                    xs: 6,
                    rootMarginRight: '0px',
                    inputTextAlign: 'center',
                    height: '1.5rem'
                },
                {
                    key: 'F1085Comment4',
                    value: formData.F1085Comment4,
                    xs: 6,
                    marginRight: '0.5rem',
                    height: '1.25rem',
                    width: '100%',
                    labelWidth: '0%',
                    textAlign: 'center',
                    marginLeft: '1.5rem',
                    maxLength: '50'

                }
            ]
        },
    ]
});
